import { HeaderLink } from './types';
import localHeaderLinks from './header-links.json';
export const defaultHeaderLinks: HeaderLink[] = localHeaderLinks as HeaderLink[];
